import React, { createContext, useContext, useEffect, useState } from 'react';
import localStorage from 'store';

const PermissionContext = createContext(null);

export const usePermission = () => useContext(PermissionContext);

export const PermissionProvider = ({ children }) => {
  const user = localStorage.get('user');
  const [isPharmacist, setIsPharmacist] = useState(false);
  const [isCallCenterOperator, setIsCallCenterOperator] = useState(false);

  useEffect(() => {
    if (user?.is_pharmacist) {
      setIsPharmacist(true);
    }

    if (user?.is_call_center_operator) {
      setIsCallCenterOperator(true);
    }
  }, [user]);

  return (
    <PermissionContext.Provider
      value={{
        user: user,
        isPharmacist: isPharmacist,
        isCallCenterOperator: isCallCenterOperator,
      }}
    >
      {children}
    </PermissionContext.Provider>
  );
};
